export default __webpack_public_path__ + "static/media/Typescript.c2eef6df.png";